/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC, useEffect } from 'react';
import { UploadingOngoing } from '../commons/FileDataSourceConfigurationStatus';
import { useAppDispatch, useAppSelector } from '@/reducers';
import { EStatus } from '@/models/fileUpload';
import { ErrorStatus } from '@/components/inputs';
import { useSaveDataSourceMutation } from '@/services/dataSources';
import { CongratulationScreen } from '@/global/components/CongratulationScreen';
import { DataSource, DataSourceFileConfig } from '@/models/dataSource';
import { StepPageActions } from '@/global/components';
import { stashDataSource } from '@/features/dataSources/dataSourcesSlice';

type FileDataSourceConfigurationCompleted = {
  onInit?: VoidFunction;
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  onCancel?: VoidFunction;
  isModal?: boolean;
};

export const FileDataSourceConfigurationCompletedStep: FC<FileDataSourceConfigurationCompleted> = ({ onInit, onNextStep, onPrevStep, onCancel, isModal }) => {
  const dispatch = useAppDispatch();

  const dataSource = useAppSelector((state) => state.dataSources.edit?.dataSource) as Partial<DataSource<DataSourceFileConfig>> | undefined;
  const fileUploadStatus = useAppSelector((state) => state.fileUploading.status);
  const fileUploadData = useAppSelector((state) => state.fileUploading.fileInfo);

  const [_, { data: savedDataSource }] = useSaveDataSourceMutation();

  useEffect(() => {
    if (savedDataSource) {
      dispatch(stashDataSource(savedDataSource.dataSource));
    }
  }, [savedDataSource]);

  useEffect(() => {
    onInit();
  }, []);

  if (dataSource?.configuration) {
    if (fileUploadStatus?.uploadingStatus === EStatus.SUCCESS) {
      return (
        <CongratulationScreen
          title='data_source_edit.code.installation_success.data_source_created_succesfully'
          subtitle='data_source_edit.code.installation_success.data_source_created_succesfully_subtitle'
          primaryButton={
            isModal
              ? {
                  text: 'data_source_edit.code.installation_success.choose_destination',
                  onClick: onNextStep,
                }
              : {
                  text: 'data_source_edit.code.installation_success.create_new_campaing',
                  onClick: onNextStep,
                }
          }
          secondaryButton={
            isModal
              ? {
                  text: 'data_source_edit.code.installation_success.add_another_data_source',
                  onClick: onPrevStep,
                }
              : {
                  text: 'data_source_edit.code.installation_success.view_all_data_sources',
                  onClick: onPrevStep,
                }
          }
        />
      );
    } else if (fileUploadStatus?.uploadingStatus === EStatus.UPLOADING) {
      return (
        <UploadingOngoing
          fileUpload={{
            status: fileUploadStatus.uploadingStatus,
            percentage: fileUploadStatus.progress || { total: 0, loaded: 0, percentageCompleted: 0 },
          }}
          filename={fileUploadData?.filename || ''}
          disabled={true}
        />
      );
    } else if (fileUploadStatus?.uploadingStatus === EStatus.ERROR) {
      return (
        <>
          <ErrorStatus error={fileUploadStatus.error} />
          <StepPageActions
            primaryButton={{
              text: 'COMMON.cancel',
              onClick: onCancel,
            }}
          />
        </>
      );
    } else {
      return null;
    }
  }
  return null;
};
